import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CardType, PaymentAccount } from '@uzurv/clara';
import { CardTypeConstants, DateFormatConstants } from '@uzurv/core';
import moment from 'moment-timezone';
import { FeatureFlagService } from 'projects/uzurv/src/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-payment-account-details',
  templateUrl: './payment-account-details.component.html',
  styleUrls: ['./payment-account-details.component.scss']
})
export class PaymentAccountDetailsComponent implements OnInit {
  @Input() paymentAccount: PaymentAccount;
  @Input() selected = false;
  @Output() edit: EventEmitter<PaymentAccount> = new EventEmitter();

  cardImageHtml: SafeHtml;

  isCreditCardValidationEnabled = false;

  constructor(private domSanitizer: DomSanitizer, private featureFlagService: FeatureFlagService) {}

  ngOnInit() {
    this.cardImageHtml = this.getCardImageHtml(this.paymentAccount.cardType);

    this.isCreditCardValidationEnabled = this.featureFlagService.isCreditCardValidationEnabled();
  }

  get isUnverified(): boolean {
    if (!this.isExpired && this.isCreditCardValidationEnabled && !this.paymentAccount.verified) {
      return true;
    }

    return false;
  }

  get isExpired(): boolean {
    if (moment(this.paymentAccount.cardExpiration).isBefore(moment())) {
      return true;
    }

    return false;
  }

  getCardImageHtml(cardType: CardType): SafeHtml {
    let imageString = '/assets/';
    const cardTypeCode = cardType?.code;

    switch (cardTypeCode) {
      case CardTypeConstants.CARD_TYPE_CODE_AMEX:
        imageString += 'amex.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_DISCOVER:
        imageString += 'discover.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_MASTER_CARD:
        imageString += 'mastercard.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_VISA:
        imageString += 'visa.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_DINERS_CLUB:
        imageString += 'dinersclub.png';
        break;

      default:
        imageString += 'credit.png';
        break;
    }
    return this.domSanitizer.bypassSecurityTrustUrl(imageString);
  }

  getHiddenCardNumberWithEnding(paymentAccount: PaymentAccount): SafeHtml {
    const cardTypeCode = paymentAccount?.cardType?.code;
    if (cardTypeCode === CardTypeConstants.CARD_TYPE_CODE_AMEX) {
      return this.domSanitizer.bypassSecurityTrustHtml(
        `****&emsp;&emsp;&emsp;&emsp;******&emsp;&emsp;&emsp;&emsp;*${paymentAccount.cardNumber}`
      );
    }
    return this.domSanitizer.bypassSecurityTrustHtml(
      `****&emsp;&emsp;&emsp;****&emsp;&emsp;&emsp;****&emsp;&emsp;&emsp;${paymentAccount.cardNumber}`
    );
  }

  formatCardExpiration(expiration: string): void {
    return moment(expiration).format(DateFormatConstants.CARD_EXPIRATION);
  }

  handleEditPaymentAccount(event: MouseEvent): void {
    event.stopPropagation();
    this.edit.emit(this.paymentAccount);
  }
}
